import {combineReducers} from 'redux';

function articles(state = [], action) {
  switch (action.type) {
    case 'FETCH_POSTS_SUCCESS':
      return action.data.items;
    default:
      return state;
  }
}

function seo(state = {}, action) {
  switch (action.type) {
    case 'FETCH_POSTS_SUCCESS':
      return action.data.seo;
    default:
      return state;
  }
}

function numPages(state = 1, action) {
  switch (action.type) {
    case 'FETCH_POSTS_SUCCESS':
      return action.data.numPages;
    default:
      return state;
  }
}

function page(state = 1, action) {
  switch (action.type) {
    case 'FETCH_POSTS_SUCCESS':
      return action.data.page;
    default:
      return state;
  }
}

function tag(state = '', action) {
  switch (action.type) {
    case 'FETCH_POSTS_SUCCESS':
      return action.data.tag;
    default:
      return state;
  }
}

function title(state = 'All Updates', action) {
  switch (action.type) {
    case 'FETCH_POSTS_SUCCESS':
      return action.data.title;
    default:
      return state;
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case 'FETCH_POSTS_REQUEST':
      return true;
    case 'FETCH_POSTS_ERROR':
    case 'FETCH_POSTS_SUCCESS':
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  articles,
  loading,
  numPages,
  page,
  tag,
  title,
  seo
});



// WEBPACK FOOTER //
// ./reducers/posts.js